import { boot } from '@dazn/bootstrap-lib';

import { CreateNS } from '../lib/createAPIBuilder';

export const installAPIAtRoot = (namespace: CreateNS) => {
    namespace(null)(({ func, prop, deps }) => {
        let taf: unknown = undefined;
        prop('taf', () => taf, {
            setter: (_taf: unknown) => {
                taf = _taf;
                return taf;
            },
        });

        prop('localStorage', deps.getAsyncStorage, null);

        func('isMoonCountry', deps.isMoonCountry);
        func('captureException', deps.captureException);

        const EVENTS: boot.event.DAZNEvent = {};
        prop('event', () => EVENTS, null);

        prop('versions', deps.getChaptersVersions, null);
        prop(
            'resourceStringsData',
            // @ts-expect-error Type 'Promise<Data>' is missing the following properties from type 'Data'
            // Technically this is wrong type. This getter CAN return Promise.
            // But this only happens before init, so in practice
            // for initialised chapter it will always return Data
            // TODO: fix this getter
            deps.getResourceStringsData,
            null,
        );
        prop('campaignId', deps.getCampaignId, null);
        prop('promoId', deps.getPromoId, null);
        prop('language', deps.getChapterLanguage, null);
        prop('sessionId', deps.getSessionId, null);
        prop('country', deps.getCountry, null);
        func('unstable_fetchSafeModeStatus', deps.fetchSafeMode);
        prop('userhomeCurrency', deps.getHomeCurrency, null);
        prop('contentCountry', deps.getContentCountry, null);
        func('unstable_handleFeEvent', deps.handleFeEvent);
        // User
        prop('userProfile', deps.getUserProfile, {
            setter: deps.setUserProfile,
            shouldNotManipulate: true,
        });
        prop('userStatus', deps.getUserStatus, {
            shouldNotManipulate: true,
        });
        prop('userType', deps.getUserType, null);
        // Deprecated
        // @ts-expect-error deprecated
        func('getUserExperiment', deps.getUserExperiment);
        // @ts-expect-error deprecated
        func('getAnonymousExperiment', deps.getAnonymousExperiment);
        prop(
            'deviceId',
            // @ts-expect-error deprecated
            deps.getDeviceId,
            {
                shouldNotManipulate: true,
                replacedWith: 'window.dazn.device.id',
            },
        );
        prop('environment', deps.getEnvironment, {
            replacedWith: 'window.dazn.application.environment',
        });
        prop('rtlEnabled', deps.isRtlEnabled, null);
        prop(
            'manufacturer',
            // @ts-expect-error deprecated
            deps.getManufacturer,
            {
                shouldNotManipulate: true,
                replacedWith: 'window.dazn.device.manufacturer',
            },
        );
        prop(
            'platform',
            // @ts-expect-error deprecated
            deps.getPlatform,
            {
                shouldNotManipulate: true,
                replacedWith: 'window.dazn.device.platform',
            },
        );
        prop(
            'experiments',
            // @ts-expect-error deprecated
            () => ({
                ...deps.getExperiments(),
                getUserExperimentNumber: deps.getUserExperimentNumber,
            }),
            {
                replacedWith: 'window.dazn.experiment (Optimizely)',
            },
        );
        prop('textToSpeech', () => deps.textToSpeechAPI, null);
        prop('unstable_closedCaptions', () => deps.closedCaptionsAPI, null);
        func('getDefaultContext', deps.getDefaultContext);
        func('getContentfulConfig', deps.getContentfulConfig);
        prop('viewerId', deps.getViewerId, null);
        prop('anonymousViewerId', deps.getAnonymousViewerId, null);
        prop('userState', deps.getUserState, null);
        prop('partnerApp', deps.getPartnerApp, null);
    });
};
